import { isDefined, tryCatch } from "@opendaw/lib-std";
import { PreferencesFacade } from "./PreferencesFacade";
import { PreferencesHost } from "./PreferencesHost";
export var Preferences;
(function (Preferences) {
    const hasLocalStorage = typeof localStorage !== "undefined";
    Preferences.host = (key, zod) => {
        const facade = new PreferencesHost(loadFromStorage(key, zod));
        if (hasLocalStorage) {
            facade.subscribeAll(() => tryCatch(() => localStorage.setItem(key, JSON.stringify(facade.settings))));
        }
        return facade;
    };
    Preferences.facade = (key, zod) => {
        const facade = new PreferencesFacade(loadFromStorage(key, zod));
        if (hasLocalStorage) {
            facade.subscribeAll(() => tryCatch(() => localStorage.setItem(key, JSON.stringify(facade.settings))));
        }
        return facade;
    };
    const loadFromStorage = (key, zod) => {
        const defaults = zod.parse({});
        if (!hasLocalStorage) {
            return defaults;
        }
        const stored = localStorage.getItem(key);
        if (!isDefined(stored)) {
            return defaults;
        }
        const { status, value } = tryCatch(() => JSON.parse(stored));
        if (status !== "success" || typeof value !== "object" || value === null) {
            return defaults;
        }
        const result = zod.safeParse(value);
        if (result.success) {
            return result.data;
        }
        // Full parse failed (schema changed). Parse each section independently to preserve valid user settings.
        const merged = {};
        for (const sectionKey of Object.keys(defaults)) {
            const sectionSchema = zod.shape?.[sectionKey];
            if (isDefined(sectionSchema) && isDefined(value[sectionKey])) {
                const sectionResult = sectionSchema.safeParse(value[sectionKey]);
                merged[sectionKey] = sectionResult.success
                    ? sectionResult.data
                    : defaults[sectionKey];
            }
            else {
                merged[sectionKey] = defaults[sectionKey];
            }
        }
        return merged;
    };
})(Preferences || (Preferences = {}));
